import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "@/common/mixins/permission";
import BridgeSystemViewPage from "./pages/BridgeSystemViewPage.vue";
import BridgeSystemSuccessOrderPage from "./pages/BridgeSystemSuccessOrderPage.vue";
import BridgeSystemQueueOrderPage from "./pages/BridgeSystemQueueOrderPage.vue";

export const BridgeSystemRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "bridgesystem"
) => [
  {
    name: "BridgeSystemViewPage",
    path: `${prefix}`,
    component: BridgeSystemViewPage,
    meta: { title: "Bridge System List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.API_BRIDGE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "BridgeSystemSuccessOrderPage",
    path: `${prefix}/success`,
    component: BridgeSystemSuccessOrderPage,
    meta: { title: "Bridge System Approve Orders" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.API_BRIDGE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "BridgeSystemQueueOrderPage",
    path: `${prefix}/queue`,
    component: BridgeSystemQueueOrderPage,
    meta: { title: "Bridge System Approve Orders" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.API_BRIDGE_ACTION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
